import React from 'react'
import { Box, Typography, TextField, Button } from '@mui/material'
import Grid from '@mui/material/Grid2'
import Link from '@mui/material/Link';

const VerifyCode = () => {
    const [value, setValue] = React.useState(0);

    return (
        <>
            <Box p={{ xs: "16px", sm: "20px", xl: "0 48px 0" }} sx={{ background: "linear-gradient(105deg, #F6F2F7 -1.91%, #FEF1F2 47.85%, #F7F3E3 80.75%)", backgroundColor: "#E6E6E6", backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center" }} display="flex" alignItems="center" justifyContent="center" minHeight={{ xs: "calc(100vh - 63px)", sm: "calc(100vh - 80px)" }}>
                <Box maxWidth="576px" width="100%">
                    <Box p={{ xs: "20px", sm: "40px" }} display="flex" flexDirection="column" justifyContent="center" alignItems="center" boxShadow="5px 5px 10.9px 0px #0000001A" border="1px solid #E9E9E9" bgcolor="#FFFFFF" margin="auto" borderRadius="4px" zIndex={{ sm: "2" }} position={{ md: "relative" }}>
                        <>
                            <Typography
                                color="#060023"
                                fontWeight="700"
                                fontSize={{ xs: "min(calc(18px + 10 * (100vw - 400px) / (1920 - 400)), 30px)", sm: "36px" }}
                            >
                                Verify Code
                            </Typography>
                            <Typography variant="body1" color="#666666" mb="24px" mt="8px" fontSize={{ xs: "min(calc(14px + 4 * (100vw - 400px) / (1920 - 400)), 16px)" }} textAlign="center">An authentication code has been sent to your email.</Typography>
                        </>

                        <Box sx={{ width: '100%' }} className="umbrella-signIn-tabs">
                            <Grid container rowSpacing={{ xs: 1, sm: 1, md: 1 }} columnSpacing={{ xs: 3, sm: 2, md: 3 }} mb="38px">
                                <Grid size={{ xs: 12 }}>
                                    <TextField
                                        variant="outlined"
                                        label="Enter Code"
                                        name="email"
                                        type='number'
                                        // value={formData.email}
                                        // onChange={handleInputChange}
                                        // error={!!formErrors.email}
                                        // helperText={formErrors.email}
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: '3px',
                                                borderColor: '#666666',
                                            },

                                            " .MuiInputLabel-root.Mui-focused": {
                                                color: "inherit",
                                            },

                                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                borderColor: '#333333',
                                                border: '1px solid'
                                            },

                                            "& .MuiOutlinedInput-input": {
                                                padding: '14px 16px',
                                                background: '#ffffff',
                                                borderRadius: '8px'
                                            },
                                            "&.MuiInputBase-input::placeholder": {
                                                color: '#333333',
                                                fontSize: '16px',
                                                opacity: '0.8'
                                            },
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>
                            <Box marginTop="25px" mb="24px">
                                <Typography variant="body2" color="#060023" display="inline">Didn’t receive the code?</Typography>
                                <Button variant="text" color="error" size='small' sx={{ textTransform: "capitalize", fontWeight: "normal", fontSize: '14px', ml: "8px" }}>
                                    Resend Code
                                </Button>
                            </Box>
                            <Button variant="contained" disableElevation sx={{ display: "flex", alignItems: "center", justifyContent: "center", textTransform: "capitalize", width: "100%", height: "51px", gap: "8px", fontSize: "16px", fontWeight: "500", bgcolor: "#178EFC !important", "&:hover": { bgcolor: "#1171cbf7 !important" } }}>
                                Submit
                            </Button>
                        </Box>
                    </Box >
                    {
                        value === 0 ? (
                            <Box className="login-authenticator-wrapper" sx={{ position: "unset!important" }}>
                                <Box
                                    className="ew-copyright"
                                    sx={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        gap: { xs: "20px", md: "unset" },
                                        justifyContent: { xs: "center" },
                                        alignItems: 'center',
                                        padding: '0 !important',
                                        position: 'unset!important',
                                        marginY: '13px!important',
                                    }}
                                >
                                    <Typography
                                        component="span"
                                        sx={{ paddingRight: "13px !important", fontWeight: "500" }}
                                        borderRight={{ xs: "none !Important", sm: "1px solid #c5c5c5 !Important" }}
                                    >
                                        &copy; 2024 All Rights Reserved
                                    </Typography>
                                    <Box
                                        component="ul"
                                        sx={{
                                            display: 'flex',
                                            listStyle: 'none',
                                            margin: 0,
                                            padding: 0,
                                            gap: '4px',
                                            position: 'relative',
                                            flexWrap: 'wrap',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <Box
                                            component="li"
                                        >
                                            <Link
                                                href="#"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className='terms'
                                                sx={{
                                                    textDecoration: 'none',
                                                    color: '#1D9652',
                                                    fontSize: '14px',
                                                    fontWeight: "500",
                                                    marginRight: "4px",
                                                    '&:hover': {
                                                        textDecoration: 'underline',
                                                    },

                                                }}
                                            >
                                                Terms of Service
                                            </Link>
                                        </Box>
                                        <Box
                                            component="li"
                                        >
                                            <Link
                                                href="#"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                sx={{
                                                    textDecoration: 'none',
                                                    color: '#1D9652',
                                                    fontSize: '14px',
                                                    fontWeight: "500",
                                                    marginRight: "4px",
                                                    '&:hover': {
                                                        textDecoration: 'underline',
                                                    },
                                                }}
                                            >
                                                Privacy Policy
                                            </Link>
                                        </Box>
                                        <Box
                                            component="li"
                                        >
                                            <Link
                                                href="#"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                sx={{
                                                    textDecoration: 'none',
                                                    fontWeight: "500",
                                                    '&:hover': {
                                                        textDecoration: 'underline',
                                                    },
                                                }}
                                            >
                                                Security
                                            </Link>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        ) : (
                            <>
                            </>
                        )
                    }</Box>
            </Box >
        </>
    )
}

export default VerifyCode